const adminNav = [
  { name: "Dashboard", path: "/dashboard" },
  { name: "Stock Management", path: "/stock" },
  { name: "Category", path: "/category" },
  { name: "Inventory", path: "/inventory" },
  { name: "Supplier", path: "/supplier" },
  { name: "Routee", path: "/routee" },
  { name: "Customer", path: "/customer" },
  { name: "Cash Management", path: "/cash" },
  { name: "Employees", path: "/employees" },
  { name: "Sales", path: "/sales" },
  { name: "Expenses", path: "/expenses" },
  { name: "Credit", path: "/credit" },
];

export default adminNav;